// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navHead {
    color: teal;
    font-size: 20px;
    font-weight: bold;
}

.info {
    font-size: 13px;
}

.cursorPointer {
    cursor: pointer;
}

.cardImage{
    background: url('my_reports.jpg') no-repeat 0 0;
    height: auto;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 80px;    
}

.cardHeader{
    height: 80px;
    margin-bottom: 0px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlcG9ydC1ob21lLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0lBQ1gsZUFBZTtJQUNmLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLGVBQWU7QUFDbkI7O0FBRUE7SUFDSSxlQUFlO0FBQ25COztBQUVBO0lBQ0ksK0NBQThFO0lBQzlFLFlBQVk7SUFDWixVQUFVO0lBQ1YsaUJBQWlCO0lBQ2pCLGtCQUFrQjtJQUNsQixvQkFBb0I7QUFDeEI7O0FBRUE7SUFDSSxZQUFZO0lBQ1osa0JBQWtCO0FBQ3RCIiwiZmlsZSI6InJlcG9ydC1ob21lLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubmF2SGVhZCB7XHJcbiAgICBjb2xvcjogdGVhbDtcclxuICAgIGZvbnQtc2l6ZTogMjBweDtcclxuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xyXG59XHJcblxyXG4uaW5mbyB7XHJcbiAgICBmb250LXNpemU6IDEzcHg7XHJcbn1cclxuXHJcbi5jdXJzb3JQb2ludGVyIHtcclxuICAgIGN1cnNvcjogcG9pbnRlcjtcclxufVxyXG5cclxuLmNhcmRJbWFnZXtcclxuICAgIGJhY2tncm91bmQ6IHVybCgnc3JjL2Fzc2V0cy9pbWFnZS9hY3Rpb25zSW1hZ2VzL215X3JlcG9ydHMuanBnJykgbm8tcmVwZWF0IDAgMDtcclxuICAgIGhlaWdodDogYXV0bztcclxuICAgIHdpZHRoOiA1MCU7XHJcbiAgICBtYXJnaW4tbGVmdDogYXV0bztcclxuICAgIG1hcmdpbi1yaWdodDogYXV0bztcclxuICAgIHBhZGRpbmctYm90dG9tOiA4MHB4OyAgICBcclxufVxyXG5cclxuLmNhcmRIZWFkZXJ7XHJcbiAgICBoZWlnaHQ6IDgwcHg7XHJcbiAgICBtYXJnaW4tYm90dG9tOiAwcHg7XHJcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/View/core/reports/report-home/report-home.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+CAA8E;IAC9E,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA,woCAAwoC","sourcesContent":[".navHead {\r\n    color: teal;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.info {\r\n    font-size: 13px;\r\n}\r\n\r\n.cursorPointer {\r\n    cursor: pointer;\r\n}\r\n\r\n.cardImage{\r\n    background: url('src/assets/image/actionsImages/my_reports.jpg') no-repeat 0 0;\r\n    height: auto;\r\n    width: 50%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    padding-bottom: 80px;    \r\n}\r\n\r\n.cardHeader{\r\n    height: 80px;\r\n    margin-bottom: 0px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
